import { render, staticRenderFns } from "./Privacy_Policy.vue?vue&type=template&id=0e60a182&scoped=true&"
import script from "./Privacy_Policy.vue?vue&type=script&lang=js&"
export * from "./Privacy_Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60a182",
  null
  
)

export default component.exports